// src/components/SaveAddressModal/SaveAddressModal.jsx
import React from "react";
import "./SaveAddressModal.css";
import { TbHome } from "react-icons/tb";
import InputField from "../InputField/InputField";
import Button from "../Button/Button";
import { useLanguage } from "../../LanguageProvider";

export default function SaveAddressModal({
  isOpen,
  onClose,
  onConfirm,
  addressName,
  setAddressName
}) {
  const { getTranslation } = useLanguage();

  if (!isOpen) return null;

  const handleConfirmClick = () => {
    // TODO: Burada adres adı için simple validation eklenebilir (örn: boşsa return).
    // Şimdilik direkt devam ediyoruz.
    onConfirm();
  };

  return (
    <div className="save-address-modal-overlay" onClick={onClose}>
      <div
        className="save-address-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="save-address-modal-icon">
          <TbHome size={22} />
        </div>

        <h2 className="save-address-modal-title">
          {getTranslation("saveAddressTitle")}
        </h2>

        <div className="save-address-modal-body">
          <InputField
            value={addressName}
            onChange={(e) => setAddressName(e.target.value)}
            placeholder={getTranslation("saveAddressPlaceholder")}
          />

          <Button
            onClick={handleConfirmClick}
            label={getTranslation("saveAddressConfirm")}
            style={{ width: "100%", marginTop: "16px" }}
          />
        </div>
      </div>
    </div>
  );
}